module.exports = __webpack_public_path__ + "static/media/Time.26468677.svg";